import React from 'react';
import {
  ColumnDef,
  ColumnFiltersState,
  OnChangeFn,
  PaginationState,
  RowSelectionState,
  SortingState,
  TableState,
} from '@tanstack/react-table';
import { RequestDocument, Variables } from 'graphql-request';
import { UseQueryObjectProps } from '../hooks/queryObjectProps.types';
import { UseQuerySqlProps } from '../hooks/useQuerySql.types';

export type DataRecord = Record<string, any>;
export enum TableSizeEnum {
  xSmall = 'xSmall',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  Tiles = 'tiles',
}

export enum FormatterType {
  boolean = 'bool',
  number = 'number',
  percentage = 'percentage',
  historicDate = 'historic-date',
  string = 'string',
  date = 'date',
  array = 'array',
  json = 'json',
  loading = 'loading',
}

export enum OptionQueryType {
  GQL = 'gql',
  SQL = 'sql',
  Object = 'queryObject',
  GQL_PAGINATION = 'gqlPagination',
}

type GqlAsyncOptions = {
  type: OptionQueryType;
  query: RequestDocument;
  variables?: Variables;
  select: (data: any) => { title: string; value: any }[];
};

type GqlPaginationAsyncOptions = {
  type: OptionQueryType;
  query: RequestDocument;
  variables?: Variables;
  select: (data: any) => { data: { title: string; value: any }[]; totals: number };
};

type SqlAsyncOptions = {
  type: OptionQueryType;
} & UseQuerySqlProps;

type QueryObjectAsyncOptions = {
  type: OptionQueryType;
} & UseQueryObjectProps;

export type AsyncGetOptions = (search: string) => GqlAsyncOptions | SqlAsyncOptions | QueryObjectAsyncOptions | GqlPaginationAsyncOptions;

export type TActiveRowId = string | null;

export interface FilterConfig {
  options?: any[];
  asyncGetOptions?: AsyncGetOptions;
  getOptions?: (data: any, label: React.ReactNode, v) => any[];
  getFilterOptionFunc?: (row: any) => { value: any; title: string };
  type?: FormatterType;
}

export interface TColumnDefMeta {
  isKey?: boolean;
  hidden?: boolean;
  filter?: FilterConfig;
}

export type RequiredIdColumnDef<TData extends DataRecord> = Omit<ColumnDef<TData>, 'meta'> & {
  id: string;
  meta?: TColumnDefMeta;
};

export type TColumnsDef = RequiredIdColumnDef<DataRecord>[];
